import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default {
  __name: 'NewAutomationButton',
  props: {
  type: { type: String, default: 'message' }
},
  setup(__props) {

const props = __props

return (_ctx, _cache) => {
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_component_router_link, {
    to: `/automation/${props.type}/new`
  }, {
    default: _withCtx(() => [
      _createVNode(_component_NeueButton, { type: "primary" }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("New automation", -1)
        ]))]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["to"]))
}
}

}